import React from "react";
import { Walking } from "styled-icons/fa-solid";
import { LocationCity } from "styled-icons/material";

import { AuthContext } from "../../authContext";

import CitySearchResults from "../shared/CitySearchResults";
import getUrbanSpaceShapeIcon from "../shared/utilities/getUrbanSpaceShapeIcon";
import HelpResultHeading from "../help/HelpResultHeading";
import HelpResult from "../help/HelpResult";
import HelpResultLink from "../help/HelpResultLink";
import housesIcon from "../../assets/images/icons/houses.svg";
import layoutIcon from "../../assets/images/icons/layout.svg";
import setLocation from "../shared/utilities/setLocation";
import CategoryDisplay from "../help/CategoryDisplay";

class SearchResults extends React.Component {
  static contextType = AuthContext;
  render()
  {
    let cityMatches = {};
    if (this.props.results.cityMatches !== undefined) {
      this.props.results.cityMatches.map(cityMatch => {
        cityMatches[cityMatch.type] = Number(cityMatch.count);
        if (Number(cityMatch.count) > 0)
          cityMatches.isCityMatch = true;
        return null;
      })
    }
    return (
      <div>
        {
          this.props.results.helpArticleCount > 0
          &&
          <div style={{marginTop: "7px"}}>
            <HelpResultHeading>CityCAD Help Articles</HelpResultHeading>
            <CategoryDisplay title="Search Results" articles={this.props.results.helpArticles} />
          </div>
        }
        {
          (this.props.cities.length > 0 && this.context.isCityCAD === true)
          &&
          <div style={{marginTop: "7px"}}>
            <HelpResultHeading>Found locations</HelpResultHeading>
            <CitySearchResults cities={this.props.cities} updateLocation={setLocation} />
          </div>
        }
        {/*{*/}
        {/*  cityMatches.isCityMatch === true*/}
        {/*  &&*/}
        {/*  <div style={{marginTop: "7px"}}>*/}
        {/*    <HelpResultHeading>Cities found in design library</HelpResultHeading>*/}
        {/*    <HelpResult>*/}
        {/*      <HelpResultLink href={`https://www.holisticcity.co.uk/database-legacy/index.php?library=displaycity&city=${this.props.searchTerms}&lang=en-GB`} target="_blank">*/}
        {/*        <LocationCity size={14} style={{marginRight: "10px"}}/> {this.props.searchTerms} : {cityMatches.streets} street{cityMatches.streets !== 1 && 's'}, {cityMatches.spaces} space{cityMatches.spaces !== 0 && 's'}, {cityMatches.housingprojects} housing project{cityMatches.housingprojects !== 1 && 's'} and {cityMatches.urbangrids} urban grid{cityMatches.urbangrids !== 1 && 's'}.*/}
        {/*      </HelpResultLink>*/}
        {/*    </HelpResult>*/}
        {/*  </div>*/}
        {/*}*/}
        {/*{*/}
        {/*  this.props.results.streetCount > 0*/}
        {/*  &&*/}
        {/*  <div style={{marginTop: "7px"}}>*/}
        {/*    <HelpResultHeading>Streets</HelpResultHeading>*/}
        {/*    {this.props.results.streets.map(street => {*/}
        {/*      return (*/}
        {/*        <HelpResult key={`street-${street.StreetID}`}>*/}
        {/*          <HelpResultLink href={`https://www.holisticcity.co.uk/database-legacy/index.php?library=displaystreets&id=${street.StreetID}`} target="_blank">*/}
        {/*            <Walking size={14} style={{marginRight: "10px"}}/> {street.Name}{street.City !== "" && <span>, {street.City}</span>}*/}
        {/*          </HelpResultLink>*/}
        {/*        </HelpResult>*/}
        {/*      )*/}
        {/*    })}*/}
        {/*  </div>*/}
        {/*}*/}
        {/*{*/}
        {/*  this.props.results.spaceCount > 0*/}
        {/*  &&*/}
        {/*  <div style={{marginTop: "7px"}}>*/}
        {/*    <HelpResultHeading>Urban Spaces</HelpResultHeading>*/}
        {/*    {this.props.results.spaces.map(space => {*/}
        {/*      return (*/}
        {/*        <HelpResult key={`street-${space.SpaceID}`}>*/}
        {/*          <HelpResultLink href={`https://www.holisticcity.co.uk/database-legacy/index.php?library=displayspaces&id=${space.SpaceID}`} target="_blank">*/}
        {/*            {getUrbanSpaceShapeIcon(space.Shape)} {space.Name}{space.City !== "" && <span>, {space.City}</span>}*/}
        {/*          </HelpResultLink>*/}
        {/*        </HelpResult>*/}
        {/*      )*/}
        {/*    })}*/}
        {/*  </div>*/}
        {/*}*/}
        {/*{*/}
        {/*  this.props.results.housingProjectCount > 0*/}
        {/*  &&*/}
        {/*  <div style={{marginTop:"7px"}}>*/}
        {/*    <HelpResultHeading>Housing Projects</HelpResultHeading>*/}
        {/*    {this.props.results.housingProjects.map(housingProject => { return (*/}
        {/*      <HelpResult key={`street-${housingProject.HousingID}`}>*/}
        {/*        <HelpResultLink href={`https://www.holisticcity.co.uk/database-legacy/index.php?library=displayhousing&id=${housingProject.HousingID}`} target="_blank">*/}
        {/*          <img src={housesIcon} style={{width:"14px", marginRight: "10px"}} alt={`Housing project icon`} /> {housingProject.Name}{housingProject.City !== "" && <span>, {housingProject.City}</span>} <span style={{marginLeft:"5px"}}>({housingProject.Dwellings} dwellings)</span>*/}
        {/*        </HelpResultLink>*/}
        {/*      </HelpResult>*/}
        {/*    )*/}
        {/*    })}*/}
        {/*  </div>*/}
        {/*}*/}
        {/*{*/}
        {/*  this.props.results.urbanGridCount > 0*/}
        {/*  &&*/}
        {/*  <div style={{marginTop:"7px"}}>*/}
        {/*    <HelpResultHeading>Urban Gridirons</HelpResultHeading>*/}
        {/*    {this.props.results.urbanGrids.map(grid => { return (*/}
        {/*      <HelpResult key={`street-${grid.GridID}`}>*/}
        {/*        <HelpResultLink href={`https://www.holisticcity.co.uk/database-legacy/index.php?library=displaygrids&id=${grid.GridID}`} target="_blank">*/}
        {/*          <img src={layoutIcon} alt={`document`} style={{width:"16px", marginRight:"10px"}} /> {grid.Name} {grid.City !== "" && <span>, {grid.City}</span>} <span style={{marginLeft:"5px"}}>({grid.Longdim}m &times; {grid.Shortdim}m {grid.Angle && <span>at {grid.Angle}&deg;</span>})</span>*/}
        {/*        </HelpResultLink>*/}
        {/*      </HelpResult>*/}
        {/*    )*/}
        {/*    })}*/}
        {/*  </div>*/}
        {/*}*/}
        {/*<div style={{marginTop:"10px"}}>*/}
        {/*  Test set location<br />*/}
        {/*  <WebLink onClick={() => this.setLocation('51.7522', '-1.25596')}>Test: change title to 'setlocation_51.7522_-1.25596'</WebLink>*/}
        {/*</div>*/}
      </div>
    )
  };
}

export default SearchResults;
